import { FieldMetadata } from '../fieldsMetadata/types';

export interface ProggresiveFields {
    fields: FieldMetadata[];
}

export enum ProggresiveFieldsActionTypes {
    UPDATED = '@@fields/UPDATED',
    UPDATE = '@@fields/UPDATE',
}